import React, { useContext, useEffect, useState } from "react";
import { RootContext } from "../../RootContextProvider";
import { Link, useHistory } from "react-router-dom";
import { Layout, Button, Divider } from "antd";
import { UserOutlined, PoweroffOutlined, EyeOutlined } from "@ant-design/icons";
import "./navbar.css";
import SelectPages from "../SelectPages/SelectPages";
import LSlogo from "../../assets/logo/linksight_visual_small.svg";
import MobileNav from "../MobileNav/MobileNav";
import PremiumTag from "../Billing/PremiumTag";
import { CopyToClipboard } from "react-copy-to-clipboard";
import ModalLinkCopied from "../ModalLinkCopied/ModalLinkCopied";
const { Header } = Layout;

const Navbar = ({ logout }) => {
  const history = useHistory();
  const { account, pages, listPages } = useContext(RootContext);

  const [moreOpen, setMoreOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const [link, setLink] = useState();
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const handleClickCopy = () => {
    setCopied(true);
    setModalIsOpen(true);
  };

  useEffect(() => {
    const setDefaultLink = () => {
      if (pages) {
        setLink("linksight.me/" + pages.PageName);
      }
    };
    setDefaultLink();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    history.listen(async () => {
      setMoreOpen(false);
    });
    // eslint-disable-next-line
  }, [history]);

  return (
    <>
      <Header className="header-navbar">
        <div className="side-top-navbar">
          {account.HasCompletedOnboarding && pages ? (
            <Link to="/links">
              <div className="logo">
                <img src={LSlogo} alt="logo linksight" />
              </div>
            </Link>
          ) : !pages && account.HasCompletedOnboarding ? (
            <Link to="/new-page">
              <div className="logo">
                <img src={LSlogo} alt="logo linksight" />
              </div>
            </Link>
          ) : (
            <Link to="/welcome">
              <div className="logo">
                <img src={LSlogo} alt="logo linksight" />
              </div>
            </Link>
          )}
        </div>
        {pages ? <SelectPages isMobile={false} /> : ""}
        {!account.IsPaying ? (
          <div className="go-premium">
            <PremiumTag size="medium" hasIcon={false} />
          </div>
        ) : (
          ""
        )}
        <div className="button-mobile-nav">
          <div
            className="burger-menu"
            onClick={() => {
              setMoreOpen(!moreOpen);
            }}
          >
            <svg
              className={
                moreOpen ? "ham hamRotate ham8 active" : "ham hamRotate ham8"
              }
              viewBox="0 0 100 100"
              width="65"
            >
              <path
                className="line top"
                d="m 30,33 h 40 c 3.722839,0 7.5,3.126468 7.5,8.578427 0,5.451959 -2.727029,8.421573 -7.5,8.421573 h -20"
              />
              <path className="line middle" d="m 30,50 h 40" />
              <path
                className="line bottom"
                d="m 70,67 h -40 c 0,0 -7.5,-0.802118 -7.5,-8.365747 0,-7.563629 7.5,-8.634253 7.5,-8.634253 h 20"
              />
            </svg>
          </div>
          {moreOpen ? (
            <div className="extra-menu-mobile-nav">
              {pages ? (
                <SelectPages isMobile={true} setMoreOpen={setMoreOpen} />
              ) : (
                ""
              )}
              <Divider />
              <Link to="/admin" className="nav-mobile-extra">
                <span>
                  <UserOutlined size={30} />
                </span>
                <span>Mon compte</span>
              </Link>
              <div
                className="nav-mobile-extra"
                onClick={() => {
                  logout();
                }}
              >
                <span>
                  <PoweroffOutlined />
                </span>
                <span>Se déconnecter</span>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </Header>
      {link && listPages.length !== 0 ? (
        <div className="block-mobile-link">
          <div className="linksight-link-mobile">
            <div className="link-part">
              <span>{link}</span>
            </div>
            <CopyToClipboard text={link} onCopy={() => handleClickCopy()}>
              <Button
                type="secondary"
                style={{
                  width: "fit-content",
                  height: "36px",
                  borderRadius: "0px 3px 3px 0px",
                }}
              >
                {!copied ? "Copier" : "Copié !"}
              </Button>
            </CopyToClipboard>
          </div>
          <div
            style={{ margin: "15px auto", textAlign: "center" }}
            className="view-page"
          >
            <a
              href={`https://${link}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#4d61fc" }}
            >
              <EyeOutlined style={{ marginRight: "5px" }} />
              Voir ma page Linksight
            </a>
          </div>
        </div>
      ) : (
        ""
      )}
      <MobileNav />
      <ModalLinkCopied
        setModalIsOpen={setModalIsOpen}
        modalIsOpen={modalIsOpen}
      />
    </>
  );
};

export default Navbar;
